/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import BarChart, { parseBarChartConfig } from "./BarChart";

const DurationBarChart = ({data, scope}) => {
  // check data exists
  const chartConfig = parseBarChartConfig(data, scope);
  const dataKeys = [{ name: "WiFi Usage Duration", key: "value" }];

  return chartConfig ? (
    <BarChart
      title="Guest Logins by WiFi Usage Duration"
      subtitle={chartConfig.name}
      data={chartConfig.data}
      dataKeys={dataKeys}
    />
  ) : null;
};

export default DurationBarChart;